import { bypassSlice } from './slices/bypass.slice';
import { tokenSlice } from './slices/token.slice';
import { lastCheckTimestampSlice } from './slices/lastCheckTimestamp.slice';

export const captchaActions = {
	...bypassSlice.actions,
	...tokenSlice.actions,
	...lastCheckTimestampSlice.actions,
};
